import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FacilityPayPeriod,
  UpdateFacilityPayPeriod
} from '@umss/shared/data-access';

@Injectable({ providedIn: 'root' })
export class FacilityPayPeriodService {
  private readonly http = inject(HttpClient);

  private getBaseUrl(facilityId: string): string {
    return `/api/facilities/${facilityId}`;
  }

  getSettings(facilityId: string): Observable<FacilityPayPeriod | null> {
    return this.http.get<FacilityPayPeriod | null>(
      `${this.getBaseUrl(facilityId)}/pay-period-settings`
    );
  }

  getHistory(facilityId: string): Observable<FacilityPayPeriod[]> {
    return this.http.get<FacilityPayPeriod[]>(
      `${this.getBaseUrl(facilityId)}/pay-period-history`
    );
  }

  updateSettings(
    facilityId: string,
    body: UpdateFacilityPayPeriod
  ): Observable<FacilityPayPeriod> {
    return this.http.put<FacilityPayPeriod>(
      `${this.getBaseUrl(facilityId)}/pay-period-settings`,
      body
    );
  }
}
